import React, { useEffect, useState } from 'react';
import { PiBinoculars } from 'react-icons/pi';
import { FiSettings } from 'react-icons/fi';
import { StudyGuideNavWeek } from './study-guide-nav-week';
import { StudyGuideReview } from './study-guide-review';
import { StudyGuideTimeline } from './study-guide-timeline';
import { useSession } from 'src/app/hooks/useSession';
import { useClient } from 'jsonapi-react';
import { Link, useLocation } from 'react-router-dom';
import { Loader } from '@/components/custom/loader';
import { EmptyState } from '@/components/custom/empty-state';
import { DashboardContent } from '@/layouts/dashboard';
import { Guide, GuideActions, GuideBody, GuideContent, GuideHeader, GuideSidebar, GuideTitle } from '@/components/custom/guide';
import { Button, ButtonIcon } from '@/components/ui/button';

export function StudyGuide() {
  const location = useLocation();
  const uri = location.pathname;
  const { session } = useSession();
  const [studyGuide, setStudyGuide] = useState(null);
  const [loading, setLoading] = useState(false);

  const client = useClient();

  const fetchData = async () => {
    setLoading(true);
    await getStudyPlan().then(async studyPlan => {
      if (!studyPlan) {
        setLoading(false);
        return;
      }
      const guide = await getStudyGuide(studyPlan.id);
      const lastBlock = getStudyBlockWithBiggerId(guide);
      setStudyGuide([lastBlock]);
    });
    setLoading(false);
  };

  const getStudyPlan = async () => {
    const response = await client.fetch('study_plans/latest');
    return response.data;
  };

  const getStudyGuide = async id => {
    const response = await client.fetch(`study_plan_blocks?filter[study_plan_id]=${id}`);
    return response.data;
  };

  const getStudyBlockWithBiggerId = studyGuide => {
    const lastBlock = studyGuide.reduce((prev, current) => (prev.id > current.id ? prev : current));
    return lastBlock;
  };

  useEffect(() => {
    fetchData();
  }, []);

  const breadcrumbs = {
    title: 'Aprendizado Dinâmico',
    nav: [
      {
        route: '/guia-de-estudos',
        name: 'Guia de estudos',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent breadcrumbs={breadcrumbs}>
      <Guide>
        <GuideHeader>
          <GuideTitle>Personalizado para {session.user.name}</GuideTitle>

          <GuideActions>
            <Button
              variant="outline"
              className="w-16"
              asChild
            >
              <Link
                to={`${uri}/funcionamento`}
                aria-label="Funcionamento"
                title="Funcionamento"
              >
                <ButtonIcon size="md">
                  <PiBinoculars />
                </ButtonIcon>
              </Link>
            </Button>
            <Button
              variant="outline"
              className="w-16"
              asChild
            >
              <Link
                to={`${uri}/configuracao`}
                aria-label="Configuração"
                title="Configuração"
              >
                <ButtonIcon size="md">
                  <FiSettings />
                </ButtonIcon>
              </Link>
            </Button>
          </GuideActions>
        </GuideHeader>

        {loading && <Loader />}

        {!loading && !studyGuide && (
          <EmptyState
            type="data"
            title="O plano de estudos não foi gerado esta semana"
            text="Você pode usar os conteúdos da plataforma enquanto aguarda o próximo."
          />
        )}

        {!loading && studyGuide && (
          <GuideBody>
            <GuideContent>
              {!loading && <StudyGuideNavWeek studyGuide={studyGuide[0]} />}
              {!loading && <StudyGuideTimeline studyGuide={studyGuide[0]} />}
            </GuideContent>

            <GuideSidebar>
              <StudyGuideReview />
            </GuideSidebar>
          </GuideBody>
        )}
      </Guide>
    </DashboardContent>
  );
}
